import React from "react";
import { useMsal } from "@azure/msal-react";

async function handleLogout(instance) {
    await instance.logoutPopup().catch(e => {
        console.error(e);
    });
}

/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
export const SignOutButton = () => {
    const { instance } = useMsal();

    return (
        <button onClick={() => handleLogout(instance)}>Sign out</button>
    );
}